import { Injectable } from '@angular/core';
import { BaseService } from '../../util/base-service.service';
import { Http } from '@angular/http';
import { HttpConst } from '../../core/resources/http/http.const';
import { HttpClient  } from '@angular/common/http';
@Injectable()
export class AuditoriaService extends BaseService {

  private $api = `${HttpConst.apiUrl}`;
  private $controllerName = 'Auditoria';
  private $controllerNamePortal = 'AuditoriaPortal'; //ADD INE(EGB) 20220709 - REQ22111

  constructor(private http: HttpClient) { super(http); }

  guardarAuditoria(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}`, input);
    return resultado;
  }
  guardarAuditoriaNavegacion(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/AuditoriaNavegacion`, input);
    return resultado;
  }

  //INICIO: INE(EGB) 20220614 - REQ22111
  guardarLogErrorPortal(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerNamePortal}/LogErrorPortal`, input);
    return resultado;
  }
  //FIN: INE(EGB) 20220614 - REQ22111

}
